import { ThemeProvider } from '@material-tailwind/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

import { RootLayout } from '@layouts/RootLayout';

import { mainRouter } from '@pages/Router';

import { componentTheme } from '@plugins/material-tailwind/componetTheme';

import { DefaultErrorBoundary } from '@/errorboundary/DefaultErrorBoundary';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3, // default : 3 >> 불필요한 재요청 최소화를 위해 설정
    },
  },
});

export const App = () => {
  const router = createBrowserRouter([
    {
      element: <RootLayout />,
      errorElement: <DefaultErrorBoundary />,
      children: [...mainRouter],
    },
  ]);

  return (
    <QueryClientProvider client={client}>
      <ThemeProvider value={componentTheme}>
        <RecoilRoot>
          <HelmetProvider>
            <RouterProvider router={router} />
          </HelmetProvider>
        </RecoilRoot>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
